import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Box} from "../../../model/box";

@Component({
  selector: 'aw-add-box-interface-dialog',
  templateUrl: './add-box-interface-dialog.component.html',
  styleUrls: ['./add-box-interface-dialog.component.scss']
})
export class AddBoxInterfaceDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Box,
    public dialogRef: MatDialogRef<AddBoxInterfaceDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


